import React from "react";
import { IoClose } from "react-icons/io5";
import Loader from "./loader";

const SuccessModal = ({
    show,
    onClose,
    icon,
    title = "Success!",
    message = "Operation completed successfully.",
    buttonText = "Close",
    onButtonClick,
    loading = false,
}) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 z-[900] flex items-center justify-center bg-black/40 px-4">
            <div className="bg-white w-full max-w-xl rounded-2xl relative text-center">
                {/* Close Button */}
                <button onClick={onClose} className="absolute top-4 right-4 text-[#101828]">
                    <IoClose size={24} />
                </button>
                <div className="px-3 pt-3 pb-2">
                    {/* Icon */}
                    <div className="flex items-center justify-center">{icon}</div>

                    {/* Title */}
                    <h2 className="text-[24px] font-[600] text-[#161827] mb-3">{title}</h2>

                    {/* Subtext */}
                    <p className="text-[#383B56] text-[16px] font-[350]">{message}</p>
                </div>
                <hr className="text] bg-[#F2F3FC]" />

                {/* Button */}
                <div className="flex justify-end px-3 pb-3 ">
                    <button
                        onClick={onButtonClick}
                        disabled={loading}
                        className={`bg-[#6F00FF] hover:bg-[#5A00D6] text-white font-[450] text-[16px] py-2.5 px-3 rounded-lg transition flex items-center justify-center gap-2 ${
                            loading ? "opacity-70 cursor-not-allowed" : ""
                        }`}
                    >
                        {loading ? <Loader /> : buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessModal;
